import mixpanel from "mixpanel-browser";
import { getIsOnpremise } from "..";
import getEnv from "../getEnv";
import { initializeCountly, trackCountlyPageView } from "./countly.util";
import { getUserProperties } from "./get-user-properties.util";
import { storeMixpanelEvents, syncMixpanelEvents } from "./store-and-sync.util";
import { trackDuration } from "./track-duration.util";
import { trackEvent } from "./track-event.util";
import { trackPageExit } from "./track-page-exit.util";
import { trackPageView } from "./track-page-view.util";
var PROD = "production";
var LOCALSTORAGE = "localStorage";
var isProduction = getEnv("NEXT_PUBLIC_APP_ENV") === PROD;
function initMixpanel() {
  var MIXPANEL_TOKEN = getEnv("NEXT_PUBLIC_MIXPANEL_TOKEN");
  var replayPercent = Number(getEnv("NEXT_PUBLIC_MIXPANEL_REPLAY_PERCENT")) || 0;
  var isOnPremise = getIsOnpremise();
  if (isOnPremise || !MIXPANEL_TOKEN) {
    return function () {};
  }
  mixpanel.init(MIXPANEL_TOKEN, {
    debug: !isProduction,
    track_pageview: false,
    persistence: LOCALSTORAGE,
    // Session Replay: record user sessions so actions are visible on the
    // Mixpanel dashboard (replays are auto-linked to tracked events).
    record_sessions_percent: replayPercent,
    // Privacy: this is a clinical platform, so mask everything on screen to
    // avoid capturing PHI/PII in replays. Add the `mp-no-mask` class on a node
    // to selectively unmask non-sensitive UI you want visible in the replay.
    record_mask_all_text: true,
    record_mask_all_inputs: true,
    record_unmask_text_selector: ".mp-no-mask",
    record_network: false,
    // Privacy: never capture console output. The SDK default records it, and
    // app logs can contain identifiers / raw payloads (PHI/PII) in a clinical app.
    record_console: false,
    // Stop recording after 1 min of inactivity so idle time isn't captured
    // (recording auto-resumes when the user is active again). Default is 30 min.
    record_idle_timeout_ms: 60000,
    // Discard very short replays (bounces / accidental loads) so they don't
    // consume the monthly replay quota. Default is 0 (keeps everything).
    record_min_ms: 5000
  });
  return function (userData) {
    mixpanel.identify(userData.username);
    mixpanel.register({
      loginSource: userData === null || userData === void 0 ? void 0 : userData.loginSource
    });
    var userProperties = getUserProperties(userData);
    mixpanel.people.set_once(userProperties);
  };
}
export { initializeCountly, initMixpanel, storeMixpanelEvents, syncMixpanelEvents, trackCountlyPageView, trackDuration, trackEvent, trackPageExit, trackPageView };